import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import {
  DeviceAdmin,
  GetAllDevices,
  GetDeviceByIdResponse,
} from '../../models/admin/device-admin.model';

@Injectable({
  providedIn: 'root',
})
export class DeviceService {
  readonly DEVICE_DATA: DeviceAdmin[] = JSON.parse(
    '[{"employeeId":"*****471","driverId":"*****471","email":"P*****Y@U*****","lastName":"TEST","firstName":"TESTER","lastLoggedIn":"2025/12/15","insertTime":"2025/08/07","os":"26.1","buildVersion":"26.1","model":"IPHONE13,2","enabled":false,"id":56,"locationCode":"PECHT"},{"employeeId":"*****410","driverId":"*****410","email":"F*****I@U*****","lastName":"SHKOKANI","firstName":"FATIMA","lastLoggedIn":"2026/03/31","insertTime":"2026/03/26","addedBy":"*****410","os":"11","buildVersion":"1.0.114","model":"TC26","enabled":true,"id":281705031,"locationCode":"PECHT"},{"employeeId":"*****792","driverId":"*****792","email":"C*****2@U*****","lastName":"PULYALA","firstName":"SRUTHI","lastLoggedIn":"2026/03/25","insertTime":"2025/12/08","addedBy":"*****792","os":"26.1","buildVersion":"26.1","model":"IPHONE13,2","enabled":true,"id":273224619,"locationCode":"PECHT"},{"employeeId":"*****226","email":"S*****I@U*****","lastName":"ZAIDI","firstName":"SYED","lastLoggedIn":"2026/04/01","insertTime":"2025/12/24","addedBy":"*****226","os":"13","buildVersion":"1.0.116","model":"SM-A037U","enabled":true,"id":274294137,"locationCode":"PECHT"}]',
  );
  constructor(private http: HttpClient) {}

  /**
   * Get all devices by location
   *
   * @param {string} _locationCode
   * @return {*}  {Observable<GetAllDevices>}
   * @memberof DeviceService
   */
  getAllDevicesByLocation(_locationCode: string): Observable<GetAllDevices> {
    // TODO: Implement API call to get devices by location when the backend API is available
    return of({ response: { devices: this.DEVICE_DATA } } as GetAllDevices);
  }

  /**
   * Get Device by Id
   *
   * @param {number} deviceId
   * @return {*}  {Observable<any>}
   * @memberof DeviceService
   */
  getDeviceById(deviceId: number): Observable<GetDeviceByIdResponse> {
    // TODO: Implement API call to get device by Id when the backend API is available
    return of({
      response: this.DEVICE_DATA.find((device) => device.id === deviceId),
    } as GetDeviceByIdResponse);
  }
}
